<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Menu</h2>

      <div class="form-wrapper">
        <form @submit.prevent="save()">
          <div class="form-group">
            <label>Nama Menu</label>
            <input type="text" v-model="data.nama" />
          </div>

          <div class="form-group">
            <label>Kategori</label>
            <select v-model="data.id_kategori">
              <option
                v-for="(item, index) in dataKategori"
                :key="index"
                :value="item.id"
              >
                {{ item.nama }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Harga jual</label>
            <input type="number" v-model="data.harga_jual" />
          </div>
          <div class="form-group">
            <label>Harga produksi</label>
            <input type="number" v-model="data.harga_produksi" />
            <span class="btn-foodcost" @click="showModal()"
              >Hitung dari foodcost</span
            >
          </div>

          <div class="form-separator">
            <p>Harga Ojek Online</p>
          </div>
          <div
            class="form-group"
            v-for="(item, index) in dataOjekOnline"
            :key="index"
          >
            <label>{{ item.nama }} ({{ item.komisi }}%)</label>
            <input type="text" v-model="item.harga_jual" />
          </div>

          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loading">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="modal" v-if="openModal" @click="hideModal">
      <div class="modal-body">
        <h3>Foodcost</h3>

        <form @submit.prevent="addFoodcost()">
          <div class="form-group bahan-baku">
            <label>Bahan baku</label>
            <input
              type="text"
              v-model="dataFoodcostSingle.bahan_baku"
              ref="ref_bahan_baku"
              @input="filterBahanBaku()"
              @keyup="chooseBahanBaku"
              @keydown.stop="selectBahanBakuIndex"
            />
            <ul v-if="showBahanBakuFilter">
              <li
                v-for="(item, index) in dataBahanBaku"
                :key="index"
                :class="{ hover: indexAutocomplete == index }"
                @click="selectBahanBaku(item)"
              >
                {{ item.nama }}
              </li>
              <li v-show="dataBahanBaku.length <= 0" class="not-found">
                <p>
                  <b>{{ dataFoodcostSingle.bahan_baku }}</b>
                  tidak ditemukan di data bahan baku.
                  <router-link to="/master/bahan-baku">Buat baru</router-link>
                </p>
              </li>
            </ul>
          </div>

          <div class="form-grid">
            <div class="form-group">
              <label>Harga</label>
              <input
                type="text"
                placeholder="Misal: 10.000"
                v-model="dataFoodcostSingle.harga"
                @input="numFormat('dataFoodcostSingle', 'harga')"
              />
            </div>
            <div class="form-group">
              <label>Per</label>
              <input
                type="text"
                placeholder="10"
                v-model="dataFoodcostSingle.per"
                @input="numFormat('dataFoodcostSingle', 'per')"
              />
            </div>
            <div class="form-group">
              <label>Satuan</label>
              <input
                type="text"
                placeholder="Gram"
                v-model="dataFoodcostSingle.satuan"
              />
            </div>
          </div>

          <div class="form-grid-2">
            <div class="form-group">
              <label>Jumlah digunakan</label>
              <input
                type="text"
                v-model="dataFoodcostSingle.jumlah"
                ref="ref_jumlah"
              />
              <span class="satuan">
                {{ dataFoodcostSingle.satuan }}
              </span>
            </div>
            <div class="form-group">
              <label>Harga per bahan</label>
              <input
                type="text"
                disabled
                :value="calculateHargaPerBahan(dataFoodcostSingle)"
              />
            </div>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-outline">Tambah</button>
          </div>
        </form>

        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Bahan baku</th>
                <th>Harga</th>
                <th>Jumlah digunakan</th>
                <th style="text-align: right">Harga per bahan</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataFoodcost" :key="index">
                <td>{{ ++index }}</td>
                <td>{{ item.bahan_baku }}</td>
                <td>
                  {{ item.harga | number }} / {{ item.per }} {{ item.satuan }}
                </td>
                <td>{{ item.jumlah }} {{ item.satuan }}</td>
                <td align="right">
                  {{ calculateHargaPerBahan(item) | number }}
                </td>
                <td>
                  <span
                    class="btn-hapus"
                    @click="removeFoodcost(item, index - 1)"
                    >&#x2715;</span
                  >
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4">
                  <b>Total harga produksi</b>
                </td>
                <td align="right">
                  <b>{{ totalFoodcost() | number }}</b>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
export default {
  name: "BahanBakuForm",
  components: {},
  data() {
    return {
      loading: false,

      data: {},
      dataFoodcostSingle: {},

      dataFoodcost: [],
      dataDeletedFoodcost: [],
      dataKategori: [],
      dataOjekOnline: [],

      dataBahanBaku: [],
      tmpDataBahanBaku: [],
      showBahanBakuFilter: false,

      indexAutocomplete: -1,

      openModal: false,
    };
  },
  methods: {
    loadKategori() {
      this.loading = true;
      api
        .get("/v4/kategori?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loading = false;
          this.dataKategori = r.data;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data kategori");
        });
    },
    loadBahanBaku() {
      this.loading = true;
      api
        .get("/v4/bahan-baku?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loading = false;
          r.data.forEach((item) => {
            item.bahan_baku = item.nama;
            this.dataBahanBaku.push(item);
          });
          this.tmpDataBahanBaku = r.data;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data kategori");
        });
    },
    loadOjekOnlen(cb) {
      api
        .get("/v4/ojek-online?id_toko=" + this.$toko.id)
        .then((r) => {
          this.dataOjekOnline = r.data;

          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.$toast("Gagal mengambil data komisi ojek online");
        });
    },
    loadData() {
      this.loading = true;
      api
        .get(
          "/v4/menu?id=" +
            this.$route.params.id +
            "&id_toko=" +
            this.$toko.id
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;

          this.loadOjekOnlen(() => {
            this.dataOjekOnline.forEach((item) => {
              const ojekOnline = this.data.harga_ojek_online.find(
                (k) => k.id_komisi == item.id_komisi
              );
              item.id_harga_ojek_online = ojekOnline.id;
              item.harga_jual = ojekOnline.harga_jual;
            });
          });

          this.dataFoodcost = this.data.food_cost;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    filterBahanBaku() {
      this.dataBahanBaku = this.tmpDataBahanBaku.filter(
        (k) =>
          k.nama
            .toLowerCase()
            .indexOf(this.dataFoodcostSingle.bahan_baku.toLowerCase()) > -1
      );

      if (this.dataFoodcostSingle.bahan_baku.length > 0) {
        this.showBahanBakuFilter = true;
      } else {
        this.showBahanBakuFilter = false;
      }
    },
    chooseBahanBaku(e) {
      if (e.which == 40) {
        // down
        if (this.indexAutocomplete < this.dataBahanBaku.length - 1) {
          this.indexAutocomplete++;
        }
      } else if (e.which == 38) {
        // up
        if (this.indexAutocomplete > 0) {
          this.indexAutocomplete--;
        }
      }
    },
    selectBahanBakuIndex(e) {
      if (e.which == 13) {
        // enter
        e.stopPropagation();
        e.preventDefault();

        const selected = this.dataBahanBaku[this.indexAutocomplete];
        this.selectBahanBaku(selected);
        this.indexAutocomplete = -1;

        this.showBahanBakuFilter = false;
        this.$refs["ref_jumlah"].focus();
      }
    },
    selectBahanBaku(item) {
      this.dataFoodcostSingle = {
        id_barang: item.id,
        bahan_baku: item.bahan_baku,
        harga: item.harga_beli,
        per: item.per,
        satuan: item.satuan,
      };

      this.showBahanBakuFilter = false;
    },
    showModal() {
      this.openModal = true;
    },
    hideModal(e) {
      if (e.target.classList[0] == "modal") {
        this.openModal = false;
      }
    },
    save() {
      if (!this.data.nama) {
        this.$toast("Nama harus diisi");
        return;
      }

      this.loading = true;
      this.data.id_toko = this.$toko.id;

      // Ojek Online
      let harga_ojol = [];
      this.dataOjekOnline.forEach((item) => {
        harga_ojol.push({
          id: item.id_harga_ojek_online,
          id_toko: this.data.id_toko,
          id_menu: this.data.id,
          id_komisi: item.id_komisi,
          harga_jual: item.harga_jual,
        });
      });
      this.data.harga_ojek_online = harga_ojol;

      // Food cost
      let food_cost = [];
      this.dataFoodcost.forEach((item) => {
        food_cost.push({
          id: item.id ? item.id : null,
          id_toko: this.data.id_toko,
          id_menu: this.data.id,
          id_barang: item.id_barang,
          bahan_baku: item.bahan_baku,
          jumlah: item.jumlah,
          harga: item.harga,
          per: item.per,
          satuan: item.satuan,
        });
      });
      this.data.food_cost = food_cost;

      // Deleted foodcost
      this.data.deleted_foodcost = this.dataDeletedFoodcost;

      api
        .post("/v4/menu/save", this.data)
        .then((r) => {
          this.loading = false;

          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast(r.message);
          }
        })
        .catch((e) => {
          this.loadingButton = false;
          this.$toast("Gagal menyimpan data");
        });
    },
    addFoodcost() {
      if (!this.dataFoodcostSingle.bahan_baku) {
        this.$toast("Nama bahan harus diisi");
        return;
      }
      if (!this.dataFoodcostSingle.harga) {
        this.$toast("Harga harus diisi");
        return;
      }
      if (!this.dataFoodcostSingle.per || !this.dataFoodcostSingle.satuan) {
        this.$toast("Satuan harus diisi");
        return;
      }
      if (!this.dataFoodcostSingle.jumlah) {
        this.$toast("Jumlah harus diisi");
        return;
      }

      this.dataFoodcost.push(this.dataFoodcostSingle);
      this.dataFoodcostSingle = {};

      this.$refs["ref_bahan_baku"].focus();
    },
    removeFoodcost(item, index) {
      this.dataDeletedFoodcost.push(item);
      this.dataFoodcost.splice(index, 1);
    },
    calculateHargaPerBahan(item) {
      const harga = parseFloat(item.harga) / parseFloat(item.per);
      const hargaDigunakan = parseFloat(item.jumlah) * harga;

      return hargaDigunakan || 0;
    },
    totalFoodcost() {
      let total = 0;

      this.dataFoodcost.forEach((item) => {
        total += (item.harga / item.per) * item.jumlah;
      });

      this.data.harga_produksi = total;
      return total;
    },
    back() {
      this.$router.go(-1);
    },
    numFormat(model, submodel) {
      this[model][submodel] = this.$options.filters.number(
        this[model][submodel].replace(/\./g, "")
      );
    },
  },
  mounted() {
    this.loadKategori();
    this.loadBahanBaku();

    if (this.$route.params.id > 0) {
      this.loadData();
    } else {
      this.loadOjekOnlen();
    }
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }
      .form-separator {
        margin: 20px 0 15px 0;
        p {
          color: var(--primary);
        }
      }
      .autocomplete {
        position: relative;
        .autocomplete-option {
          position: absolute;
          background-color: #fff;
          border: 1px solid #ccc;
          box-shadow: 0px 2px 3px #ccc;
          border-radius: 5px;
          width: 100%;
          margin-top: 10px;
          ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
            li {
              padding: 10px;
              font-size: 14px;
              border-bottom: 1px solid #ccc;
              &.active {
                background-color: var(--primary);
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .form-group {
    position: relative;
    span.btn-foodcost {
      position: absolute;
      top: 30px;
      right: 5px;
      font-size: 13px;
      border: 1px solid var(--primary);
      color: var(--primary);
      padding: 5px;
      border-radius: 4px;
      cursor: pointer;
      &:active {
        background-color: #eee;
      }
    }

    span.satuan {
      position: absolute;
      top: 35px;
      right: 5px;
      font-size: 13px;
      color: #777;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .modal-body {
      background: #fff;
      padding: 15px;
      height: fit-content;
      margin-top: 100px;
      border-radius: 10px;
      width: 800px;
      label {
        font-size: 14px;
      }
      h3 {
        margin-top: 0;
      }

      form {
        width: 430px;
      }

      .form-grid {
        display: grid;
        grid-template-columns: 200px 100px 100px 150px;
        grid-column-gap: 15px;
      }

      .form-grid-2 {
        display: grid;
        grid-template-columns: 200px 215px;
        grid-column-gap: 15px;
      }

      .bahan-baku {
        position: relative;
        ul {
          padding: 0;
          margin: 0;
          margin-top: 5px;
          width: 100%;
          position: absolute;
          background-color: #fff;
          z-index: 2;
          border-radius: 4px;
          border: 1px solid #ccc;
          list-style-type: none;
          max-height: 300px;
          overflow-y: auto;
          box-shadow: 0px 3px 6px #ccc;

          li {
            padding: 10px 15px;
            cursor: pointer;
            font-size: 14px;
            &:hover,
            &.hover {
              background-color: #f7f7f7;
              &:active {
                background-color: #eee;
              }
            }

            &.not-found {
              p {
                font-size: 14px;
              }
              a {
                color: var(--primary);
              }
            }
          }
        }
      }

      .input-group {
        border: 1px solid #ccc;
        border-radius: 4px;
        display: grid;
        grid-template-columns: 1fr 24px 90px 60px;

        &:focus-within {
          border-color: var(--primary);
        }

        label {
          display: flex;
          align-items: center;
          color: #777;
          margin-bottom: 0;
        }
        input {
          border: 0;
          &:nth-child(3) {
            text-align: right;
            padding-left: 10px;
            padding-right: 0;
          }
          &:nth-child(4) {
            padding-left: 0;
            padding-right: 0;
            width: calc(100% - 10px);
          }
        }
      }

      .table-wrapper {
        height: 250px;
        overflow-y: auto;

        tfoot {
          position: sticky;
          bottom: 0;
          background-color: #fff;
          border-top: 1px solid #ccc;
          td {
            padding: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/master/MenuForm.vue